<template>
  <div class="insights-ia-page">
    <InsightsIAAgentTabs />
    <div class="insights-ia-page__content">
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
import { diContainer } from "@/inversify.config";
import InsightsIAAgentTabs from "./components/InsightsIAAgentTabs.vue";
import { insightsConfiguracaoContainer } from "./widgets/configuracao/container/insightsConfiguracaoContainer";
import { onUnmounted } from "vue";
import { insightsDreContainer } from "./views/agenteDeDRE/container/InsightsDreContainer";

diContainer.load(insightsDreContainer);
diContainer.load(insightsConfiguracaoContainer);

onUnmounted(() => {
  diContainer.unload(insightsDreContainer);
  diContainer.unload(insightsConfiguracaoContainer);
});
</script>

<style scoped lang="scss">
.insights-ia-page {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - (52px + 52px + 12px));

  &__content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
}
</style>
